import { inject, Inject, Injectable, InjectionToken, NgZone } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';

import { runInZone } from '../../../shared/utils/run-in-zone';
import { APP_CONFIG_TOKEN } from '../abstracts/app-config.abstract';

interface BroadcastMessage {
  type: string;
  payload: any;
}

export const BROADCAST_NAME_SERVICE_TOKEN = new InjectionToken<BroadcastService>('BROADCAST_NAME_SERVICE_TOKEN');
export const BROADCAST_SERVICE_TOKEN = new InjectionToken<BroadcastService>('BROADCAST_SERVICE_TOKEN');

@Injectable({
  providedIn: 'root'
})
export class BroadcastService {
  private readonly ngZone = inject(NgZone);
  private readonly appconfig = inject(APP_CONFIG_TOKEN);
  private readonly broadcastChannel: BroadcastChannel;
  private readonly onMessage = new Subject<any>();

  constructor(@Inject(BROADCAST_NAME_SERVICE_TOKEN) broadcastChannelName: string) {
    this.broadcastChannel = new BroadcastChannel(broadcastChannelName);
    this.broadcastChannel.onmessage = message => this.onMessage.next(message.data);
  }

  publish(message: BroadcastMessage): void {
    this.broadcastChannel.postMessage(message);
  }

  messagesOfType(type: string): Observable<BroadcastMessage> {
    return this.onMessage.pipe(
      // It is important that we are running in the NgZone.
      // This will make sure that Angular component changes are immediately visible in the browser when they are updated after receiving messages.
      runInZone(this.ngZone),
      filter(message => message.type === type)
    );
  }
}
